import { render, staticRenderFns } from "./ScreenTabFilterControl.vue?vue&type=template&id=5bf65b85&scoped=true&"
import script from "./ScreenTabFilterControl.vue?vue&type=script&lang=js&"
export * from "./ScreenTabFilterControl.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTabFilterControl.vue?vue&type=style&index=0&id=5bf65b85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf65b85",
  null
  
)

export default component.exports